/** 업종별 10개 데모 — 각각 다른 레이아웃 템플릿 */
export const DESIGN_TEMPLATES = [
  "split-classic",
  "minimal-light",
  "dark-immersive",
  "soft-rounded",
  "editorial",
  "bento",
  "sidebar",
  "timeline",
  "brutalist",
  "glass-modern",
];

export const DEMO_DESIGN_MAP = {
  hospital: {
    "hi-medical": "split-classic",
    "green-dental": "soft-rounded",
    "prime-checkup": "minimal-light",
    "joy-obgyn": "editorial",
    "clear-eye": "glass-modern",
    "bone-ortho": "brutalist",
    "skin-aesthetic": "dark-immersive",
    "kids-pediatric": "bento",
    "han-heart": "timeline",
    "neuro-brain": "sidebar",
  },
  corporate: {
    nexus: "split-classic",
    "atlas-logistics": "dark-immersive",
    "vertex-bio": "soft-rounded",
    "stellar-media": "editorial",
    "quantum-tech": "glass-modern",
    "green-energy": "bento",
    "harbor-trade": "sidebar",
    "prime-consulting": "minimal-light",
    "forge-mfg": "brutalist",
    "summit-holdings": "timeline",
  },
  cafe: {
    "morning-brew": "split-classic",
    "matcha-house": "soft-rounded",
    "roast-lab": "brutalist",
    "sweet-bean": "editorial",
    "urban-drip": "minimal-light",
    "slow-cup": "sidebar",
    "forest-bean": "bento",
    "drip-line": "glass-modern",
    "cream-top": "timeline",
    "night-owl": "dark-immersive",
  },
  restaurant: {
    hanokdam: "editorial",
    "sushi-gin": "minimal-light",
    "pasta-bella": "soft-rounded",
    "spice-road": "bento",
    "bbq-fire": "dark-immersive",
    "ramen-yoko": "brutalist",
    "brunch-table": "glass-modern",
    "wine-cellar": "sidebar",
    "vegan-leaf": "timeline",
  },
  bank: {
    "first-digital": "glass-modern",
    "city-bank": "split-classic",
    "regional-trust": "soft-rounded",
    "capital-invest": "dark-immersive",
    "savings-mutual": "timeline",
    "union-credit": "bento",
    "global-finance": "sidebar",
    "youth-bank": "editorial",
    "senior-care": "minimal-light",
    "fintech-lab": "brutalist",
  },
};

const INDUSTRY_FEATURES = {
  hospital: [
    { title: "전문 의료진", desc: "분야별 전문의 협진 체계" },
    { title: "온라인 예약", desc: "24시간 모바일 예약·문진" },
    { title: "프라이빗 진료", desc: "1인 진료실·대기 혼잡 최소화" },
    { title: "검진 원스톱", desc: "검사부터 결과 상담까지 한 곳에서" },
  ],
  corporate: [
    { title: "전략 컨설팅", desc: "비즈니스 성장 로드맵 설계" },
    { title: "기술 구현", desc: "검증된 SI·클라우드 역량" },
    { title: "데이터 분석", desc: "인사이트 기반 의사결정 지원" },
    { title: "지속 파트너십", desc: "장기 운영·고도화 지원" },
  ],
  cafe: [
    { title: "시그니처 메뉴", desc: "시즌 한정 음료·디저트" },
    { title: "직접 로스팅", desc: "싱글 오리진·핸드 드립" },
    { title: "매장 경험", desc: "좌석·음악·공간 디자인" },
    { title: "멤버십 혜택", desc: "적립·쿠폰·생일 리워드" },
  ],
  restaurant: [
    { title: "시그니처 메뉴", desc: "셰프 특선·제철 식재료" },
    { title: "예약 시스템", desc: "온라인 예약·코스 선택" },
    { title: "프라이빗 공간", desc: "룸·단체석·기념일 연출" },
    { title: "와인 페어링", desc: "소믈리에 추천 페어링" },
  ],
  bank: [
    { title: "맞춤 상품", desc: "예금·대출·카드 통합 안내" },
    { title: "디지털 뱅킹", desc: "모바일·인터넷 뱅킹" },
    { title: "자산 관리", desc: "펀드·ISA·연금 상담" },
    { title: "24시간 상담", desc: "고객센터·챗봇 지원" },
  ],
};

export function getDesignTemplate(industry, demoId) {
  return DEMO_DESIGN_MAP[industry]?.[demoId] ?? "split-classic";
}

export function getIndustryFeatures(industry) {
  return INDUSTRY_FEATURES[industry] ?? INDUSTRY_FEATURES.corporate;
}
